import React from 'react';
import classes from './StatsCard.module.scss';

function StatsCard({ title, value }) {
  const displayValue =
    value !== undefined && value !== null ? value.toString() : 'N/A';
  return (
    <div className={classes['statsCard_outer']}>
      <div className={classes['statsCard_inner']}>
        <h5>{title}</h5>
        <p>{displayValue}</p>
      </div>
    </div>
  );
}

export default StatsCard;
